interface NotifyMeta {
  notify?: boolean
  retry?: unknown
  request?: unknown
  [key: string]: unknown
}

interface NotifyAction {
  type?: string | { NOTIFY?: string }
  meta?: NotifyMeta
  payload?: unknown
  [key: string]: unknown
}

type Next = (action: NotifyAction) => unknown

export default (_store: unknown) => (next: Next) => (action: NotifyAction) => {
  if (action.meta?.notify) {
    delete action.meta.retry
    delete action.meta.request
    action.payload = { data: action.payload }
    if (action.type && typeof action.type === 'object' && typeof action.type.NOTIFY === 'string') {
      action.type = action.type.NOTIFY
    }
  }
  return next(action)
}
